__turbopack_context__.v({
  "bottom": "glass-toast-module__smqRMa__bottom",
  "content": "glass-toast-module__smqRMa__content",
  "glass": "glass-toast-module__smqRMa__glass",
  "orange": "glass-toast-module__smqRMa__orange",
  "solid": "glass-toast-module__smqRMa__solid",
  "toast": "glass-toast-module__smqRMa__toast",
  "top": "glass-toast-module__smqRMa__top",
});
